<template>
  <div class="unmarkable">
    <canvas
      :id="pickIndex + 'colorControlRow'"
      width="5"
      height="5"
      @click="handleCanvasClick"
    ></canvas>
    <div
      class="square"
      :style="{ height: squareDimension + 'px', width: squareDimension + 'px' }"
    >
      {{ cppp }}
    </div>
  </div>
</template>

<script>
import colorConverter from "../../utils/colorControlColors";
import {
  TOGGLE_REGULATOR,
  FILE_MODIFIED
} from "../../../store/modules/uptData/constants";
import eventBus from "../../utils/eventBus";
const _ = require("lodash");

export default {
  name: "ColorControlRow",
  props: {
    colorControlData: { type: Array, required: true },
    squareDimension: { type: Number, required: true },
    pickIndex: { type: Number, required: true },
    colorControlAmount: { type: Number, required: true },
    colorIndex: { type: Number, default: null }
  },

  mounted: function() {
    this.cppp = this.colorControlData[2];
    this.draw();
  },

  data: function() {
    return {
      cppp: null
    };
  },

  watch: {
    squareDimension() {
      this.draw();
    },
    colorControlData() {
      this.draw();
    }
  },

  computed: {
    editColorControl() {
      return this.$store.state.uptData.editColorControl;
    }
  },

  methods: {
    draw(colorIndex = this.colorIndex) {
      this.cppp = this.colorControlData[2];
      const color = colorConverter.getColorFromIndex(colorIndex);
      var canvas = document.getElementById(this.pickIndex + "colorControlRow");
      if (canvas.getContext) {
        const ctx = canvas.getContext("2d");
        const width =
          (this.squareDimension + 2) * (this.colorControlAmount + 1);
        ctx.canvas.width = width;
        const height = this.squareDimension;
        ctx.canvas.height = height;
        ctx.fillStyle = color;
        ctx.strokeStyle = "black";
        ctx.lineWidth = 1;
        const squaresToDraw = [
          ..._.takeRight(this.colorControlData[0], this.colorControlAmount),
          this.colorControlData[1]
        ];
        squaresToDraw.forEach((jacquardValue, i) => {
          if (i >= this.colorControlAmount) {
            ctx.fillStyle = "#000000";
          }
          if (jacquardValue) {
            ctx.fillRect(
              i * this.squareDimension + i * 2,
              0,
              this.squareDimension,
              this.squareDimension
            );
          } else {
            ctx.strokeRect(
              i * this.squareDimension + i * 2 + 0.5,
              0 + 0.5,
              this.squareDimension - 1,
              this.squareDimension - 1
            );
          }
        });
      }
    },
    async handleCanvasClick(event) {
      if (this.editColorControl) {
        let clickedIndex =
          32 -
          this.colorControlAmount +
          Math.floor(event.offsetX / (this.squareDimension + 2));
        if (clickedIndex === 32) {
          await this.$store.dispatch(TOGGLE_REGULATOR, {
            pickIndex: this.pickIndex,
            currentValue: this.colorControlData[1]
          });
        } else {
          const oldIndex = this.colorControlData[0].findIndex(c => c === 1);
          this.colorControlData[0][oldIndex] = 0;
          this.colorControlData[0][clickedIndex] = 1;
        }
        this.$store.dispatch(FILE_MODIFIED);
        eventBus.$emit("pickUpdate", { index: this.pickIndex });
      }
    }
  }
};
</script>

<style scoped>
canvas {
  vertical-align: bottom;
}

.square {
  margin: 0px 1px;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
}
</style>
